<template>
	<div class="d-flex justify-start align-center">
		<v-img v-if="preview" :src="modelValue" width="100" height="100" @click="showPreview"></v-img>
		<v-dialog v-model="previewDlg" width="80%">
			<v-card>
				<v-card-text>
					<v-img :src="modelValue" width="100%" height="100%"></v-img>
				</v-card-text>
			</v-card>
		</v-dialog>
		<image-chooser ref="imagechooser" @chosen="onImageChosen" :show-cropper="true">
			<slot v-bind="{ progress, trigger }">
				<template v-if="progress > 0 && progress < 100">
					<v-progress-linear v-model="progress" color="blue" height="10"></v-progress-linear>
					<v-btn color="primary" @click="cancel" outlined>取消</v-btn>
				</template>
				<template v-else>
					<!-- <v-btn color="primary" @click="trigger">点击上传</v-btn> -->
				</template>
			</slot>
		</image-chooser>
	</div>
</template>

<script>
import ImageChooser from './ImageChooser.vue'
import axios from 'axios'

export default {
	components: {
		ImageChooser
	},
	props: {
		modelValue: { type: String, default: '' },
		multiple: { type: Boolean, default: false },
		accept: { type: String, default: 'image/*' },
		config: { type: String, default: 'default' },
		preview: { type: Boolean, default: false }
	},
	data() {
		return {
			dialog: false,
			imageUrl: '',
			selectedFile: null,
			upconfig: {},
			files: [],
			progress: 0,
			tries: {}, //filename:times
			retryLimit: 2,
			total: 0,
			cancelToken: null,
			previewDlg: false
		}
	},
	mounted() {
		this.loadConfig()
	},
	methods: {
		onImageChosen({ blob, name }) {
			const formData = new FormData()
			formData.append('file', blob, name)
			this.upload(formData, name)
		},
		trigger() {
			this.$refs.imagechooser.trigger()
		},
		showPreview() {
			this.previewDlg = true
		},
		loadConfig() {
			this.$api.common.upconfig(
				this.config,
				(r) => {
					this.upconfig = r
				},
				(e) => {
					console.log(e)
				}
			)
		},
		validateFileSize(files, each = 2) {
			const maxSize = each * 1024 * 1024 // 2MB
			for (let i = 0; i < files.length; i++) {
				if (files[i].size > maxSize) {
					return false
				}
			}
			return true
		},

		cancel() {
			if (this.cancelToken) {
				this.cancelToken.cancel('取消上传')
			}
		},
		upload(formData, file) {
			formData.append('policy', this.upconfig['policy'])
			formData.append('signature', this.upconfig['signature'])

			var self = this
			var url = 'https://v0.api.upyun.com/' + this.upconfig.bucket + '/'
			const CancelToken = axios.CancelToken
			const source = CancelToken.source()
			this.cancelToken = source

			axios
				.post(url, formData, {
					method: 'post',
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					cancelToken: source.token,
					transformRequest: [
						function (data) {
							return data
						}
					],
					onUploadProgress: function (e) {
						var percentage = Math.round((e.loaded * 100) / e.total) || 0
						if (percentage <= 100) {
							self.progress = percentage
							console.log(percentage + '%') // 上传进度
						}
					}
				})
				.then((resp) => {
					var imgurl = self.upconfig.cdn + resp.data.url
					// console.log('uploaded', this.total, imgurl)
					self.files.push(imgurl)
					self.onUploaded([imgurl])
				})
				.catch((error) => {
					if (axios.isCancel(error)) {
						console.log('Upload canceled')
						this.onUploadCancel()
					} else {
						if (!this.tries[file.name]) this.tries[file.name] = 1
						if (this.tries[file.name] < this.retryLimit) {
							this.loadConfig()
							this.tries[file.name]++
							this.upload(formData, file)
						} else {
							alert('上传失败，请重试')
							this.onUploadFail()
						}
					}
				})
		},
		onUploadFail(e) {
			this.$emit('fail', e)
			this.progress = 0
			this.$refs.imagechooser.reset()
		},
		onUploadCancel() {
			this.$emit('cancel')
			this.progress = 0
			this.$refs.imagechooser.reset()
		},
		onUploaded(file) {
			this.$emit('uploaded', file)
			this.$emit('update:modelValue', file[0])
			this.$refs.imagechooser.reset()
			this.progress = 0
		},
		onUploadedAll() {
			this.$emit('uploadedAll', this.files)
		}
	}
}
</script>

<style scoped>
/* Add any additional styles here */
</style>
